


























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Modal extends Vue {
  @Prop({ required: false }) public containerClasses: string;
  @Prop({ required: false, default: true }) public closeOutside: boolean;
  @Prop({ required: false, default: true }) public showCancel: boolean;

  public mounted() {
    document.addEventListener("keyup", this.onEscKey, false);
  }

  public destroyed() {
    document.removeEventListener("keyup", this.onEscKey);
  }

  private emitOutsideClick() {
    if (this.closeOutside) {
      this.$emit("close");
    }
  }

  private onEscKey(event: any) {
    if (event.keyCode === 27 || event.key === "Escape") {
      this.$emit("close");
    }
  }
}
